import { render, staticRenderFns } from "./AlbumGallery.vue?vue&type=template&id=02703f6a&"
import script from "./AlbumGallery.vue?vue&type=script&lang=ts&"
export * from "./AlbumGallery.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports